import { useMemo } from 'react'

import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-enterprise'

import { capitaliseWords } from '@fortem-monorepo/js-utilities'
import { CustomAgGrid, createColDefs } from '@fortem-monorepo/react-ag'
import type { ICReport } from '@fortem-monorepo/web-sdk'

export interface CtaExposureAggregatedTableProps {
  data?: ICReport.CtaExposureData['aggregated']
  loading?: boolean
}

export const CtaExposureAggregatedTable: React.FC<CtaExposureAggregatedTableProps> = ({
  data,
  loading,
}) => {
  const colDefs = useMemo(() => {
    return createColDefs([
      {
        field: 'asset_class',
        headerName: 'Asset Class',
      },
      {
        field: 'instrument_name',
        headerName: 'Instrument Name',
      },
      ...Object.keys(data?.[0].weights ?? {}).map(
        (key) =>
          ({
            field: key,
            headerName: capitaliseWords(key),
            valueGetter: (params: ValueGetterParams) => {
              return params.data.weights?.[key]
            },
            valueFormatter: (params: ValueFormatterParams) => {
              if (params.value) {
                return (params.value * 100).toFixed(2)
              }

              return params.value
            },
          }) satisfies ColDef,
      ),
    ])
  }, [data])

  return <CustomAgGrid loading={loading} rowData={data} columnDefs={colDefs} />
}
